// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchExamples-cls1_SZo","cls2":"ResearchExamples-cls2_nSa ResearchExamples-cls1_SZo"};